var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconDeleteCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm4.2 17.9L12 13.8 7.9 18l-1.8-1.8 4.1-4.2L6 7.9l1.8-1.8 4.2 4.1L16.1 6l1.8 1.8-4.1 4.2 4.2 4.1-1.8 1.8z"
  })));
}

export default SvgIconDeleteCircle;